var path = '/templates/projects/views/directives/projects_menu_search.html';
var html = "<li class=\"dropdown navbar-profile\" dropdown ng-show=Devise.isMaster()><a class=dropdown-toggle dropdown-toggle ng-click=focusOnSearch()><i class=\"glyphicon glyphicon-search\"></i></a><ul class=dropdown-menu role=menu><li><project-search on-select=goHome(project)></project-search></li></ul></li>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_modules/projects/views/directives/projects_menu_search.html
// module id = 1563
// module chunks = 0